import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function TextField(theme: Theme) {
  return {
    MuiTextField: {
      defaultProps: {
        InputProps: {
          style: {},
        },
      },
      styleOverrides: {
        root: {},
        input: {},
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.MuiInputBase-root': {
            height: '44px',
          },
          '&.MuiInputBase-multiline': {
            height: 'auto',
            padding: 0,
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--dk-line, #E7E9EC)',
          },
        },
        input: {
          '&.MuiInputBase-input': {
            height: 'auto',
            padding: '12px',
            fontSize: '14px',
            lineHeight: '20px',
          },
          '&.MuiInputBase-inputMultiline': {
            height: 'auto',
            padding: '16px',
            fontSize: '14px',
            lineHeight: '20px',
          },
        },
      },
    },
  };
}
